import { RT_API_DEMO } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  modelName: 'DEMO',
  config: null,
  fetchConfigStatus: null,
  fetchConfigError: null,
  demoResponse: null,
  demoResponseStatus: null,
  demoResponseError: null,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RT_API_DEMO.UNSET:
      return {
        ...state,
        [action.payload]: INITIAL_STATE[action.payload],
      };
    case RT_API_DEMO.FETCH_CONFIG:
      return {
        ...state,
        fetchConfigStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_DEMO.FETCH_CONFIG_FAILURE:
      return {
        ...state,
        fetchConfigError: action.payload,
        fetchConfigStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_DEMO.FETCH_CONFIG_SUCCEEDED:
      return {
        ...state,
        config: action.payload,
        fetchConfigStatus: CONSTANTS.API.SUCCEEDED,
      };
    case RT_API_DEMO.SUBMIT_DEMO:
      return {
        ...state,
        demoResponseStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_DEMO.SUBMIT_DEMO_FAILURE:
      return {
        ...state,
        demoResponseError: action.payload,
        demoResponseStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_DEMO.SUBMIT_DEMO_SUCCEEDED:
      return {
        ...state,
        demoResponse: action.payload,
        demoResponseStatus: CONSTANTS.API.SUCCEEDED,
      };
    default:
      return state;
  }
};
